<template>
  <el-dialog
    v-if="currentZoruu"
    :title="currentZoruu.order_number + ' дугаартай захиалгын зөрүү'"
    :visible.sync="isShow"
    v-loading="differenceLoading"
    :close-on-click-modal="isOpenDialog"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="mCloseFunction"
    width="25%"
    >
      <el-form v-model="currentZoruu">
        <el-form-item label="Зөрүү тэмдэглэл">
          <el-input
            v-model="currentZoruu.balance_note"
            type="textarea"
            :rows="5"
            :disabled="currentZoruu.is_balance ? false : true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="currentZoruu.is_balance"
            >Зөрүүтэй захиалга</el-checkbox
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mCloseFunction">Болих</el-button>
        <el-button type="success" @click="saveDifference">Хадгалах</el-button>
      </div>
    </el-dialog>
</template>
<script>
export default {
  name: 'ZoruuDialog',
  props: {
    isShow: Boolean,
    closeFunction: Function,
    saveDifference: Function,
    close: Function,
    currentZoruu: Object,
    differenceLoading: Boolean
  },
  data () {
    return {
      isOpenDialog: false
    }
  },
  methods: {
    mCloseFunction () {
      this.closeFunction()
    }
  }
}
</script>
